define((require) => {
    "use strict";

    const _      = require("underscore");
    const Effect = require("shared/ui/experience/action/effects/EffectModel");

    const TYPE = "pulse";

    return Effect.extend({
        defaults: _.defaults({
            type: TYPE,
            value: 3
        }, Effect.prototype.defaults)
    }, {
        TYPE
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/effects/PulseEffectModel.js